import { render, staticRenderFns } from "./SignalementPratiqueIllegale.vue?vue&type=template&id=d37dc0ea"
import script from "./SignalementPratiqueIllegale.vue?vue&type=script&lang=js"
export * from "./SignalementPratiqueIllegale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports